import useMedia from '@hooks/useMedia';
import Slider, { ResponsiveObject, Settings } from 'react-slick';
import { css } from 'styled-components';

interface InnerSlider {
  list?: HTMLDivElement;
}

interface SliderExtended extends Slider {
  // innerSlider is set when slick is initialised - null when using responsive setting 'unslick'
  innerSlider?: InnerSlider | undefined;
}

export const slickCss = css`
  /* Slider */
  .slick-slider {
    position: relative;

    display: block;
    box-sizing: border-box;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }

  .slick-list {
    position: relative;

    display: block;
    overflow: hidden;

    margin: 0;
    padding: 0;
  }

  .slick-list:focus {
    outline: none;
  }

  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }

  .slick-slider .slick-track,
  .slick-slider .slick-list {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  .slick-track {
    position: relative;
    top: 0;
    left: 0;

    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .slick-track:before,
  .slick-track:after {
    display: table;

    content: '';
  }

  .slick-track:after {
    clear: both;
  }

  .slick-loading .slick-track {
    visibility: hidden;
  }

  .slick-slide {
    display: none;
    float: left;

    height: 100%;
    min-height: 1px;
  }

  [dir='rtl'] .slick-slide {
    float: right;
  }

  .slick-slide img {
    display: block;
  }

  .slick-slide.slick-loading img {
    display: none;
  }

  .slick-slide.dragging img {
    pointer-events: none;
  }

  .slick-initialized .slick-slide {
    display: block;
  }

  .slick-loading .slick-slide {
    visibility: hidden;
  }

  .slick-vertical .slick-slide {
    display: block;

    height: auto;

    border: 1px solid transparent;
  }

  .slick-arrow.slick-hidden {
    display: none;
  }
`;

export const slickThemeCss = css`
  /* Slider */
  .slick-loading .slick-list {
    background: #fff;
  }

  /* Icons */
  /* @font-face {
  font-family: 'slick';
  font-weight: normal;
  font-style: normal;

  src: url('./fonts/slick.eot');
  src: url('./fonts/slick.eot?#iefix') format('embedded-opentype'), url('./fonts/slick.woff') format('woff'), url('./fonts/slick.ttf') format('truetype'), url('./fonts/slick.svg#slick') format('svg');
} */

  /* Arrows */
  .slick-prev,
  .slick-next {
    font-size: 0;
    line-height: 0;

    position: absolute;
    top: 50%;

    display: block;

    width: 20px;
    height: 20px;
    padding: 0;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);

    cursor: pointer;

    color: transparent;
    border: none;
    outline: none;
    background: transparent;
  }

  .slick-prev:hover,
  .slick-prev:focus,
  .slick-next:hover,
  .slick-next:focus {
    color: transparent;
    outline: none;
    background: transparent;
  }

  .slick-prev:hover:before,
  .slick-prev:focus:before,
  .slick-next:hover:before,
  .slick-next:focus:before {
    opacity: 1;
  }

  .slick-prev.slick-disabled:before,
  .slick-next.slick-disabled:before {
    opacity: 0.25;
  }

  .slick-prev:before,
  .slick-next:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;

    opacity: 0.75;
    color: white;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .slick-prev {
    left: -25px;
  }

  [dir='rtl'] .slick-prev {
    right: -25px;
    left: auto;
  }

  .slick-prev:before {
    content: '←';
  }

  [dir='rtl'] .slick-prev:before {
    content: '→';
  }

  .slick-next {
    right: -25px;
  }

  [dir='rtl'] .slick-next {
    right: auto;
    left: -25px;
  }

  .slick-next:before {
    content: '→';
  }

  [dir='rtl'] .slick-next:before {
    content: '←';
  }

  /* Dots */
  .slick-dotted.slick-slider {
    margin-bottom: 30px;
  }

  .slick-dots {
    position: absolute;
    bottom: -25px;

    display: block;

    width: 100%;
    padding: 0;
    margin: 0;

    list-style: none;

    text-align: center;
  }

  .slick-dots li {
    position: relative;

    display: inline-block;

    width: 20px;
    height: 20px;
    margin: 0 5px;
    padding: 0;

    cursor: pointer;
  }

  .slick-dots li button {
    font-size: 0;
    line-height: 0;

    display: block;

    width: 20px;
    height: 20px;
    padding: 5px;

    cursor: pointer;

    color: transparent;
    border: 0;
    outline: none;
    background: transparent;
  }

  .slick-dots li button:hover,
  .slick-dots li button:focus {
    outline: none;
  }

  .slick-dots li button:hover:before,
  .slick-dots li button:focus:before {
    opacity: 1;
  }

  .slick-dots li button:before {
    font-family: 'slick';
    font-size: 6px;
    line-height: 20px;

    position: absolute;
    top: 0;
    left: 0;

    width: 20px;
    height: 20px;

    content: '•';
    text-align: center;

    opacity: 0.25;
    color: black;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .slick-dots li.slick-active button:before {
    opacity: 0.75;
    color: black;
  }
`;

/**
 * Slick Slider common next() function - will check if reference is null, and if it's not, triggers slider.slickNext()
 * @param slider Slider reference - i.e. sliderRef.current
 * @param callback Side effects to run after slider.slickNext();
 * @returns void
 */
export const next = (slider: Slider | null, callback?: () => void): void => {
  const sliderExtended: SliderExtended | null = slider;

  if (sliderExtended === null || sliderExtended.innerSlider === null) {
    return;
  }

  sliderExtended.slickNext();

  if (callback) {
    callback();
  }
};

/**
 * Slick Slider common previous() function - will check if reference is null, and if it's not, triggers slider.slickPrev()
 * @param slider Slider reference - i.e. sliderRef.current
 * @param callback Side effects to run after slider.slickPrev();
 * @returns void
 */
export const previous = (slider: Slider | null, callback?: () => void): void => {
  const sliderExtended: SliderExtended | null = slider;

  if (sliderExtended === null || sliderExtended.innerSlider === null) {
    return;
  }

  sliderExtended.slickPrev();

  if (callback) {
    callback();
  }
};

/**
 * Slick Slider common reset() function - will check if reference is null, and if it's not, triggers slider.goTo(0)
 * @param slider Slider reference - i.e. sliderRef.current
 * @param callback Side effects to run after slider.goTo(0);
 * @returns void
 */
export const reset = (slider: Slider | null, callback?: () => void): void => {
  const sliderExtended: SliderExtended | null = slider;

  if (sliderExtended === null || sliderExtended.innerSlider === null) {
    return;
  }

  sliderExtended.slickGoTo(0);

  if (callback) {
    callback();
  }
};

/**
 * Slick Slider common goTo() function - will check if reference is null, and if it's not, triggers slider.goTo(index)
 * @param slider Slider reference - i.e. sliderRef.current
 * @param newIndex Index value to go to - will invoke slider.goTo(newIndex)
 * @param callback Side effects to run after slider.goTo(newIndex);
 * @returns void
 */
export const goTo = (slider: Slider | null, newIndex: number, callback?: () => void): void => {
  const sliderExtended: SliderExtended | null = slider;

  if (sliderExtended === null || sliderExtended.innerSlider === null) {
    return;
  }

  sliderExtended.slickGoTo(newIndex);

  if (callback) {
    callback();
  }
};

export const getSlidesForCurrentBreakpoint = (slider: Slider | null): number => {
  // We need access to the current breakpoint slick is using to do the following logic //
  // This isn't available in the API for some reason, so we need to access the state using an any variable //
  if (slider) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const slickCurrent: any = slider;
    const stateBreakpoint = slickCurrent.state.breakpoint;
    if (stateBreakpoint) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const currentBreakpoint = slickCurrent.props.responsive.find((x: any) => x.breakpoint === stateBreakpoint);
      if (currentBreakpoint) {
        // We now have the number of slides that are currently being displayed at this breakpoint //
        return currentBreakpoint.settings.slidesToShow;
      }
    } else {
      // We must be on the default breakpoint //
      return slickCurrent.props.slidesToShow;
    }
  }

  return 0;
};

export type ResponsiveConfig = Pick<Settings, 'slidesToShow' | 'responsive'>;

export function useSlides(
  queries: Array<string>,
  values: Array<number>,
  defaultValue: number,
): [number, ResponsiveConfig] {
  // Workaround for our implementation of react-slick.
  // Changing the slidesToShow using useMedia value directly doesn't make the correct slides aria-hidden
  // This issue would mean some slides would never be focusable with makeHiddenNonFocusable

  const value = useMedia(queries, values, defaultValue);

  // Create Slick responsive config array
  const createResponsiveConfig = (): ResponsiveConfig => {
    let mappedValues = queries
      .map((query, index) => ({
        value: values[index],
        isFrom: query.includes('min-width'),
        breakpoint: +query.replace(/\D/g, ''),
      }))
      .filter((pair) => pair.value > -1)
      // Descending order
      .sort((a, b) => b.breakpoint - a.breakpoint);

    let isFrom = mappedValues.every((pair) => pair.isFrom);
    const isUntil = mappedValues.every((pair) => !pair.isFrom);

    // Log error if isFrom is not the same for all queries (note: this isn't an issue anywhere at the time of writing)
    if (!isFrom && !isUntil) {
      console.error('All queries must be "from" queries (min-width) or "until" queries (max-width)');
      // Fallback to isFrom
      mappedValues = mappedValues.filter((pair) => pair.isFrom);
      isFrom = true;
    }

    const responsive: ResponsiveObject[] = [];
    let slidesToShow = defaultValue;
    // Create responsive config for "from" queries (min-width)
    // Slick uses max-width breakpoints. Example with 2 slides, 3 above 720, 4 above 1024:
    // slidesToShow: 4, responsive: [{breakpoint: 1024, settings: {slidesToShow: 3}, {breakpoint: 720, settings: {slidesToShow: 2}}]
    if (isFrom) {
      // Set default to the first value - largest breakpoint
      slidesToShow = mappedValues[0].value;

      // Convert to max-width breakpoints
      mappedValues.forEach((pair, index) => {
        const nextValue = mappedValues[index + 1];
        responsive.push({
          breakpoint: pair.breakpoint - 1,
          settings: {
            slidesToShow: nextValue ? nextValue.value : defaultValue,
            slidesToScroll: 1,
          },
        });
      });
    } else {
      // Create responsive config for "until" queries (max-width)
      mappedValues.forEach((pair) => {
        responsive.push({
          breakpoint: pair.breakpoint,
          settings: {
            slidesToShow: pair.value,
            slidesToScroll: 1,
          },
        });
      });
    }

    return { slidesToShow, responsive };
  };

  const responsiveConfig = createResponsiveConfig();

  return [value, responsiveConfig];
}

export const makeHiddenNonFocusable = (elementRef: React.MutableRefObject<HTMLElement | null>): (() => void) => {
  // Workaround for issue in react-slick. Open issue: https://github.com/akiran/react-slick/issues/2400
  // Returns a function that can be called on init and afterChange, makes focusable elements non-focusable while a slide is hidden for accessibility
  // https://dequeuniversity.com/rules/axe/4.10/aria-hidden-focus
  return () => {
    // Check if elementRef is set before attempting to use it
    if (!elementRef.current) {
      // Element not yet available, so we have to delay
      // Lighthouse will flag the issue, but it is a false positive once the element is available
      // Attempted fixing by using aria-busy but this is ignored by Lighthouse.
      setTimeout(() => {
        makeHiddenNonFocusable(elementRef)();
      }, 0);
      return;
    }

    elementRef.current
      .querySelectorAll(
        `
          .slick-slide[aria-hidden="true"] a:not([tabIndex="-1"]),
          .slick-slide[aria-hidden="true"] button:not([tabIndex="-1"])`,
      )
      .forEach((el) => {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('hidden-non-focus', 'true');
      });

    elementRef.current
      .querySelectorAll(
        `
          .slick-slide:not([aria-hidden="true"]) a[hidden-non-focus="true"],
          .slick-slide:not([aria-hidden="true"]) button[hidden-non-focus="true"]`,
      )
      .forEach((el) => {
        el.removeAttribute('tabindex');
        el.removeAttribute('hidden-non-focus');
      });
  };
};
